import React from 'react';

export default function Replay() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.01 31.16">
      <path d="M12.85,5.32c-1.39,.19-2.74,.64-3.96,1.34-3.18,1.74-5.33,4.9-5.78,8.5-.85,6.29,3.56,12.07,9.85,12.92,6.11,.82,11.79-3.33,12.85-9.41,.46-2.51,.06-5.1-1.14-7.35-.41-.73-.16-1.65,.57-2.06s1.65-.16,2.06,.57c.02,.03,.03,.06,.05,.1,.94,1.79,1.49,3.76,1.62,5.78,.28,3.6-.84,7.17-3.12,9.97-2.47,3.2-6.2,5.18-10.24,5.44C7.63,31.74,.66,25.77,.04,17.79-.53,10.43,4.53,3.81,11.79,2.43c.33-.06,.66-.12,1.06-.19,0-.55-.02-1.1,0-1.66,0-.2,.07-.5,.2-.57s.42,.04,.59,.14c1.57,.98,3.13,1.97,4.69,2.96,.08,.05,.15,.1,.23,.15,.34,.25,.37,.56,.01,.78-1.7,1.09-3.4,2.17-5.11,3.23-.36,.23-.59,.08-.6-.36-.01-.52,0-1.04,0-1.61" />
      <path d="M11.41,10.27l9.26,6.4-9.26,6.4V10.27Z" />
    </svg>
  );
}
